import script from "./GoToComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./GoToComponent.vue?vue&type=script&lang=ts&setup=true"

import "./GoToComponent.vue?vue&type=style&index=0&id=68bc27b0&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68bc27b0"]])

export default __exports__